import { EquipmentItemBaseInterface, EquipmentItemType } from "@features/equipment/types/equipment-item-base.interface";

export enum TelescopeType {
  REFRACTOR_ACHROMATIC = "REFRACTOR_ACHROMATIC",
  REFRACTOR_SEMI_APOCHROMATIC = "REFRACTOR_SEMI_APOCHROMATIC",
  REFRACTOR_APOCHROMATIC = "REFRACTOR_APOCHROMATIC",
  REFRACTOR_NON_ACHROMATIC_GALILEAN = "REFRACTOR_NON_ACHROMATIC_GALILEAN",
  REFRACTOR_NON_ACHROMATIC_KEPLERIAN = "REFRACTOR_NON_ACHROMATIC_KEPLERIAN",
  REFRACTOR_SUPERACHROMAT = "REFRACTOR_SUPERACHROMAT",
  REFRACTOR_PETZVAL = "REFRACTOR_PETZVAL",

  REFLECTOR_DALL_KIRKHAM = "REFLECTOR_DALL_KIRKHAM",
  REFLECTOR_NASMYTH = "REFLECTOR_NASMYTH",
  REFLECTOR_RITCHEY_CHRETIEN = "REFLECTOR_RITCHEY_CHRETIEN",
  REFLECTOR_GREGORIAN = "REFLECTOR_GREGORIAN",
  REFLECTOR_HERSCHELLIAN = "REFLECTOR_HERSCHELLIAN",
  REFLECTOR_NEWTONIAN = "REFLECTOR_NEWTONIAN",
  REFLECTOR_DOBSONIAN = "REFLECTOR_DOBSONIAN",
  REFLECTOR_CLASSICAL_CASSEGRAIN = "REFLECTOR_CLASSICAL_CASSEGRAIN",

  CATADIOPTRIC_ARGUNOV_CASSEGRAIN = "CATADIOPTRIC_ARGUNOV_CASSEGRAIN",
  CATADIOPTRIC_KLEVTSOV_CASSEGRAIN = "CATADIOPTRIC_KLEVTSOV_CASSEGRAIN",
  CATADIOPTRIC_LURIE_HOUGHTON = "CATADIOPTRIC_LURIE_HOUGHTON",
  CATADIOPTRIC_MAKSUTOV = "CATADIOPTRIC_MAKSUTOV",
  CATADIOPTRIC_MAKSUTOV_CASSEGRAIN = "CATADIOPTRIC_MAKSUTOV_CASSEGRAIN",
  CATADIOPTRIC_MAKSUTOV_NEWTONIAN = "CATADIOPTRIC_MAKSUTOV_NEWTONIAN",
  CATADIOPTRIC_MODIFIED_DALL_KIRKHAM = "CATADIOPTRIC_MODIFIED_DALL_KIRKHAM",
  CATADIOPTRIC_SCHMIDT_CAMERA = "CATADIOPTRIC_SCHMIDT_CAMERA",
  CATADIOPTRIC_SCHMIDT_CASSEGRAIN = "CATADIOPTRIC_SCHMIDT_CASSEGRAIN",
  CATADIOPTRIC_ACF_SCHMIDT_CASSEGRAIN = "CATADIOPTRIC_ACF_SCHMIDT_CASSEGRAIN",
  CATADIOPTRIC_ROWE_ACKERMAN_SCHMIDT = "CATADIOPTRIC_ROWE_ACKERMAN_SCHMIDT",
  CATADIOPTRIC_RICCARDI_HONDERS = "CATADIOPTRIC_RICCARDI_HONDERS",
  CATADIOPTRIC_MODIFIED_HARMER_WYNNE = "CATADIOPTRIC_MODIFIED_HARMER_WYNNE",

  CAMERA_LENS = "CAMERA_LENS",
  BINOCULARS = "BINOCULARS",

  OTHER = "OTHER"
}

export interface TelescopeInterface extends EquipmentItemBaseInterface {
  type: TelescopeType;
  aperture?: number;
  minFocalLength?: number;
  maxFocalLength?: number;
  weight?: number;
}

export function instanceOfTelescope(object: EquipmentItemBaseInterface): object is TelescopeInterface {
  return !!object && object.klass === EquipmentItemType.TELESCOPE;
}
